export default __webpack_public_path__ + "static/media/uploader-caresens-1.66eaf067.png";